<template>
    <div class="chart-div">
        <highcharts ref="highchartsRef" :options="chartOptions"></highcharts>
    </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import { BLUE_COLOUR } from '@/constants/colours.js'
import PatientsRepository from '@/repositories/PatientsRepository'
import selfEvaluationTestMixin from '@/mixins/selfEvaluationTest.mixin'

const TEST_NOT_COMPLETED = -1

export default {
    mixins: [selfEvaluationTestMixin],
    components: {
        'highcharts': Chart
    },
    data () {
        return {
            total: 0,
            completed: 0,
            colorsArray: []
        }
    },
    props: {
        testList: {
            type: Array,
            required: true
        }
    },
    created () {
        PatientsRepository.GetLastCompletedFromEachTest().then((response) => {
            response.data.forEach(({ testName, monthResult }) => {
                var resultInfo = null
                if (monthResult !== TEST_NOT_COMPLETED) resultInfo = this.testResultsInfo(testName, monthResult)
                if (this.testList.includes(testName)) {
                  this.total += 1
                  this.completed += monthResult === TEST_NOT_COMPLETED ? 0 : 1
                  this.colorsArray.push(this.testEvaluationColor(resultInfo, testName, monthResult))
                }
            })
        })
    },
    computed: {
        chartOptions () {
            var _this = this
            return {
                chart: {
                    type: 'pie',
                    backgroundColor: 'transparent',
                    spacing: 0,
                    height: '90',
                    width: '90'
                },
                title: {
                    text: ''
                },
                subtitle: {
                    useHTML: true,
                    text: `<span style="font-size: 12px; color: ${BLUE_COLOUR}">
                            <b>${_this.completed}/${_this.total}</b>
                        </span>`,
                    floating: true,
                    verticalAlign: 'middle'
                },
                credits: {
                    enabled: false
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        borderWidth: 1,
                        type: 'pie',
                        linecap: 'square',
                        size: '100%',
                        innerSize: '80%',
                        dataLabels: {
                            enabled: false
                        },
                        states: {
                            hover: {
                                enabled: false
                            },
                            inactive: {
                                enabled: false
                            }
                        }
                    }
                },
                colors: _this.colorsArray,
                series: [
                    {
                        type: 'pie',
                        data: Array.from({ length: _this.total }, () => 100 / _this.total)
                    }
                ]
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.chart-div {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/ProgressChart.vue